import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { defaultTab: String }

  connect() {
    this.showTab(this.defaultTabValue)
  }

  change(event) {
    event.preventDefault()
    const tab = event.params.tab
    this.showTab(tab)
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tabId
    this.showTab(tabId)
  }

  showTab(activeTab) {
    // Handle both old and new tab formats
    this.tabTargets.forEach(tab => {
      const tabName = tab.dataset.tab || tab.dataset.tabId
      const activeClasses = tab.dataset.activeClasses?.split(" ") || ["bg-sz-primary-600", "text-white"]
      const inactiveClasses = tab.dataset.inactiveClasses?.split(" ") || ["text-gray-500", "hover:text-gray-700"]
      
      if (tabName === activeTab) {
        tab.classList.add(...activeClasses)
        tab.classList.remove(...inactiveClasses)
      } else {
        tab.classList.remove(...activeClasses)
        tab.classList.add(...inactiveClasses)
      }
    })

    this.panelTargets.forEach(panel => {
      const panelTab = panel.dataset.tab || panel.dataset.panelId
      if (panelTab === activeTab) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
